'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerServicesLifecycleEvents = exports.triggerModelLifecycleEvents = undefined;
exports.atomUpdate = atomUpdate;
exports.findMatchedReactions = findMatchedReactions;
exports.reactionReducer = reactionReducer;

var _ramda = require('ramda');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _model = require('../model');

var _diff2 = require('../diff');

var _path = require('../path');

var _get_reactions = require('./get_reactions');

var _get_reactions2 = _interopRequireDefault(_get_reactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var reactionDebug = (0, _debug2.default)('modula:reaction');

var hasLifeCycleMethod = function hasLifeCycleMethod(lifeCycleMethodName) {
  return (0, _ramda.pipe)((0, _ramda.prop)(lifeCycleMethodName), (0, _ramda.is)(Function));
};

var callModelLifeCycleAsPromise = function callModelLifeCycleAsPromise(lifeCycleMethodName) {
  return function (m) {
    return new Promise(function (resolve) {
      reactionDebug('triggering ' + lifeCycleMethodName + ' for model', m);

      resolve(m[lifeCycleMethodName]());
    });
  };
};

var mapModelDidMountToPromises = (0, _ramda.pipe)((0, _ramda.filter)(hasLifeCycleMethod('modelDidMount')), (0, _ramda.map)(callModelLifeCycleAsPromise('modelDidMount')));

var mapModelWillUnmountToPromises = (0, _ramda.pipe)((0, _ramda.filter)(hasLifeCycleMethod('modelWillUnmount')), (0, _ramda.map)(callModelLifeCycleAsPromise('modelWillUnmount')));

var mapModelDidUpdateToPromises = (0, _ramda.pipe)((0, _ramda.filter)((0, _ramda.pipe)((0, _ramda.prop)('newModel'), hasLifeCycleMethod('modelDidUpdate'))), (0, _ramda.map)(function (_ref) {
  var oldModel = _ref.oldModel,
      newModel = _ref.newModel;
  return new Promise(function (resolve) {
    reactionDebug('triggering modelDidUpdate for model', oldModel, newModel);

    resolve(newModel.modelDidUpdate(oldModel, newModel));
  });
}));

// given 3 mapping function
// apply 3 arguments to 3 functions respectively
// and run all returned promises with Promise.all
var runInParallelWith = (0, _ramda.unapply)((0, _ramda.useWith)((0, _ramda.pipe)((0, _ramda.unapply)(_ramda.flatten), function (promises) {
  return Promise.all(promises);
})));

var triggerModelLifecycleEvents = exports.triggerModelLifecycleEvents = runInParallelWith(mapModelDidMountToPromises, mapModelWillUnmountToPromises, mapModelDidUpdateToPromises);

var callServiceLifeCycleAsPromise = function callServiceLifeCycleAsPromise(lifeCycleMethodName) {
  return function (s) {
    return new Promise(function (resolve) {
      reactionDebug('triggering ' + lifeCycleMethodName + ' for service', s);

      resolve(s[lifeCycleMethodName]());
    });
  };
};

// return model services which has specified lifecycle
var getServicesWithLifeCycle = function getServicesWithLifeCycle(lifeCycleMethodName) {
  return (0, _ramda.pipe)((0, _ramda.invoker)(0, 'getServices'), _ramda.values, (0, _ramda.filter)(hasLifeCycleMethod(lifeCycleMethodName)));
};

var mapServiceModelDidMountToPromises = (0, _ramda.pipe)((0, _ramda.map)(getServicesWithLifeCycle('modelDidMount')), _ramda.flatten, (0, _ramda.map)(callServiceLifeCycleAsPromise('modelDidMount')));

var mapServiceModelWillUnmountToPromises = (0, _ramda.pipe)((0, _ramda.map)(getServicesWithLifeCycle('modelWillUnmount')), _ramda.flatten, (0, _ramda.map)(callServiceLifeCycleAsPromise('modelWillUnmount')));

var mapServiceModelDidUpdateToPromises = (0, _ramda.pipe)((0, _ramda.map)((0, _ramda.converge)(_ramda.map, [function (um) {
  return (0, _ramda.assoc)('service', _ramda.__, um);
}, (0, _ramda.pipe)((0, _ramda.prop)('newModel'), getServicesWithLifeCycle('modelDidUpdate'))])), _ramda.flatten, (0, _ramda.map)(function (_ref2) {
  var oldModel = _ref2.oldModel,
      newModel = _ref2.newModel,
      service = _ref2.service;
  return new Promise(function (resolve) {
    reactionDebug('triggering service modelDidUpdate for model', oldModel, newModel, service);

    resolve(service.modelDidUpdate(oldModel, newModel));
  });
}));

var triggerServicesLifecycleEvents = exports.triggerServicesLifecycleEvents = runInParallelWith(mapServiceModelDidMountToPromises, mapServiceModelWillUnmountToPromises, mapServiceModelDidUpdateToPromises);

function houseKeeping(mountedModels, unmountedModels, updatedModels) {
  (0, _ramda.forEach)(function (m) {
    (0, _model.ensureParentPointerOnChildModels)(m, true);
  }, mountedModels);

  (0, _ramda.forEach)(function (m) {
    (0, _model.setAsPhasingOut)(m);
  }, unmountedModels);

  (0, _ramda.forEach)(function (_ref3) {
    var newModel = _ref3.newModel;

    (0, _model.ensureParentPointerOnChildModels)(newModel, true);
    (0, _model.setAsLatestInstance)(newModel);
  }, updatedModels);
}

function atomUpdate(oldRootModel, path, newReactorModel) {
  return (0, _ramda.reduceRight)(function (p, memo) {
    var current = memo.getIn(p);

    if ((0, _model.isModel)(current) && current.modelWillUpdate) {
      return memo.updateIn(p, current.modelWillUpdate(oldRootModel.getIn(p)));
    } else {
      return memo;
    }
  }, oldRootModel.updateIn(path, newReactorModel), (0, _path.getIntermidiatePaths)(path));
}

function applyReaction(rootModel, reaction, action) {
  reactionDebug('apply reaction', rootModel, reaction, action);

  var reactorModel = rootModel.getIn(action.path);

  var reactionResult = reaction.update(reactorModel, action);

  if (!(0, _ramda.is)(Array, reactionResult)) {
    throw new Error('Reaction for ' + action.type + ' did not return an array. Did you mean `return [ newModel ]`?');
  }

  var _reactionResult = _toArray(reactionResult),
      newReactorModel = _reactionResult[0],
      sideEffects = _reactionResult.slice(1);

  if (!(0, _model.isModel)(newReactorModel)) {
    throw new Error('Reaction for ' + action.type + ' did not return a new model');
  }

  if (!(0, _ramda.all)((0, _ramda.is)(Function), sideEffects)) {
    throw new Error('Some side effects for ' + action.type + ' are not functions');
  }

  // updateIn and modelWillUpdate in one transaction
  var newRootModel = atomUpdate(rootModel, action.path, newReactorModel);

  var _diff = (0, _diff2.diff)(rootModel, newRootModel, action.path),
      mountedModels = _diff.mountedModels,
      unmountedModels = _diff.unmountedModels,
      updatedModels = _diff.updatedModels;

  // trigger some side effects which is required for house keeping
  // such as set latest instance
  // and setup parent pointers etc


  houseKeeping(mountedModels, unmountedModels, updatedModels);

  if (action.meta && action.meta.imported) {
    reactionDebug('found imported actions from DevTools', 'skip side effects and life cycle events for imported actions');

    return [newRootModel, function () {
      return triggerServicesLifecycleEvents(mountedModels, unmountedModels, updatedModels);
    }];
  } else {
    return [newRootModel].concat(_toConsumableArray(sideEffects), [function () {
      return triggerModelLifecycleEvents(mountedModels, unmountedModels, updatedModels);
    }, function () {
      return triggerServicesLifecycleEvents(mountedModels, unmountedModels, updatedModels);
    }]);
  }
}

function findMatchedReactions(rootModel, action) {
  var reactorModel = rootModel.getIn(action.path);

  if (reactorModel) {
    var reactions = (0, _get_reactions2.default)(reactorModel);

    return (0, _ramda.filter)(function (reaction) {
      if (reaction) {
        return reaction.type === action.type;
      } else {
        throw new Error('A receiver in ' + reactorModel.displayName + ' doesn\'t return a valid reaction');
      }
    }, reactions);
  } else {
    return [];
  }
}

function reactionReducer(model, action) {
  var matchedReactions = findMatchedReactions(model, action);
  var numberOfReactions = matchedReactions.length;

  if (numberOfReactions > 1) {
    reactionDebug('found more than one match reactions', action, matchedReactions);

    throw new Error('Unable to handle more than one matched reactions');
  } else if (numberOfReactions === 1) {
    var reactionToApply = matchedReactions[0];

    return applyReaction(model, reactionToApply, action);
  } else {
    reactionDebug((0, _ramda.join)(' ', ['action does not change the state, ', 'it could be missing the reactions in model, ', 'or the model structure had changed and was unable to process the action']), action);

    return [model];
  }
}